export default class TeamMembers {
  constructor() {
    this.classNames = {
      block: 'b-af-team-members',
      teamMembers: 'c-af-team-member',
      modal: 'c-af-team-member__modal',
      close: 'c-af-team-member__modal-close',
    }

    this.blocks = this.getTeamMembersBlocks();

    if (this.blocks.length > 0) {
      this.init(this.blocks);
    }
  }

  init(blocks) {
    blocks.forEach(block => {
      this.modals(block);
    });
  }

  modals(block) {
    const teamMembers = block.querySelectorAll(`.${this.classNames.teamMembers}`);

    teamMembers.forEach((member) => {
      const modal = member.querySelector(`.${this.classNames.modal}`);
      const close = member.querySelector(`.${this.classNames.close}`);

      member.addEventListener('click', () => {
        event.stopPropagation();
        modal.classList.add('open');
        document.documentElement.style.overflow = 'hidden';
      });

      close.addEventListener('click', () => {
          this.modalClose(modal);
      });

      modal.addEventListener('click', (event) => {
        if (event.target == modal) {
          this.modalClose(modal);
        }
      });
    });
  }

  modalClose(modal) {
    event.stopPropagation();
    modal.classList.remove('open');
    document.documentElement.style.overflow = 'visible';
  }

  getTeamMembersBlocks() {
    return Array.from(document.querySelectorAll(`.${this.classNames.block}`));
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/teamMembers.js